<!-- 校友活动点击核销码  跳转至该页面
同时也是领取核销码页面点击核销码  跳转至该页面 -->
<template>
  <div class="code">
    <img src="../../assets/image/btn_hexiaoma_nor.png" alt="" class="codeBackImg" />
    <div class="title">{{ this.title }}</div>
    <div class="receivedDate">领取时间：{{ this.active.createTime }}</div>
    <div class="codeImgDiv">
      <img :src="this.active.qrcodeUrl" alt="二维码" class="codeImg" />
    </div>
    <div class="ticketNum">卡券号码：{{ this.active.qrcode }}</div>
    <div class="tips">（请在使用时向工作人员出示二维码）</div>
    <div class="contactsTitle">
      联系人：{{ this.contact }}
      <div class="telDiv">
        <a :href="this.contactsTel">
          <img src="../../assets/image/btn_dianhuawhite_nor.png" alt="电话" class="telImg" />
        </a>
      </div>
    </div>
    <div class="adress">地址：{{ this.adress }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "",
      activeDetail: '',
      contactsTel: "",
      contact: '',
      title: '',
      adress: '',
      postCode: {
        userId: window.localStorage.getItem("user_id"),
        schoolActivityId: this.$route.query.schoolactivity_id,
      },
      postWelfareCode: {
        userId: window.localStorage.getItem("user_id"),
        wId: this.$route.query.wid,
      },
    };
  },
  created() {
    if (this.postCode.schoolActivityId !== undefined) {
      this.getActive();
      this.getActiveDetail();
    }
    if (this.postWelfareCode.wId !== undefined) {
      this.getWelfare();
      this.getWelfareDetail();
    }
  },
  methods: {
    async getActive() {
      const result = await this.$http.get("/schoolActivity/getActivityApplyInfo", {
        params: this.postCode,
      });
      this.active = result.data;
      this.contactsTel = "tel" + ":" + this.active.phone;
    },
    async getActiveDetail() {
      const result = await this.$http.get("/schoolActivity/getActivityShowByName", {
        params: { userId: window.localStorage.getItem("user_id"), id: this.postCode.schoolActivityId },
      });
      this.activeDetail = result.data.ActivityShowByName;
      this.contactsTel = "tel" + ":" + this.activeDetail.sbhPhone;
      this.title = this.activeDetail.sbhTitle;
      this.contact = this.activeDetail.sbhContacts;
      this.adress = this.activeDetail.sbhAddress;
    },
    async getWelfare() {
      console.log(this.postWelfareCode);
      const result = await this.$http.get("/alumniCard/getWelfareLog", {
        params: this.postWelfareCode,
      });
      this.active = result.data;
      this.active.qrcodeUrl = result.data.qrcode;
      this.active.qrcode = result.data.code;
      this.active.createTime = result.data.creDate;
      this.contactsTel = "tel" + ":" + this.active.phone;
    },
    async getWelfareDetail() {
      const result = await this.$http.get("/alumniCard/getSchoolHomeById", {
        params: this.postWelfareCode,
      });
      this.activeDetail = result.data;
      this.contactsTel = "tel" + ":" + this.activeDetail.phone;
      this.title = this.activeDetail.schoolName;
      this.contact = this.activeDetail.contact;
      this.adress = this.activeDetail.address;
    },
    gotoIndex() {
      return this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scoped>
.code {
  position: relative;

  .codeBackImg {
    width: 100%;
  }

  .title {
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; */
  }

  .receivedDate {
    position: absolute;
    top: 11%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-weight: bold;
    color: #ffffff;
  }

  .codeImgDiv {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    width: 30%;
    height: 30vw;

    .codeImg {
      width: 100%;
      height: 100%;
    }
  }

  .ticketNum {
    position: absolute;
    top: 64%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-weight: bold;
    color: #ffffff;
  }

  .tips {
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-weight: bold;
    color: #ffffff;
  }

  .contactsTitle {
    position: absolute;
    top: 82%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    color: #ffffff;
  }

  .telDiv {
    float: right;
    margin-left: 8px;
    width: 15px;

    .telImg {
      width: 100%;
    }
  }

  .adress {
    position: absolute;
    top: 88%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-weight: bold;
    color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mine/ActiveCode.vue